import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { useGetReflexVendedores } from "~pages/ResearchManagement/hooks/useResearchManagementRequests";

const useReflex = () => {
  const [reflex, setReflex] = useState([]);
  const [loading, setLoading] = useState(true);

  const { data: queryData, isLoading: apiLoading, isError } = useGetReflexVendedores();

  useEffect(() => {
    const loadData = async () => {

      if (apiLoading) return;

      try {
        const indexedData = await db.reflex.toArray();


        if (!isError && queryData && queryData.length > 0) {
          setReflex(queryData);


          await db.reflex.clear();
          await db.reflex.bulkAdd(queryData);

          setLoading(false);
          return;
        }


        if (indexedData && indexedData.length > 0) {
          setReflex(indexedData);
          setLoading(false);
          return;
        }


        setReflex([]);
      } catch (err) {
        console.error("Erro ao carregar reflex:", err);


        const indexedData = await db.reflex.toArray();
        setReflex(indexedData || []);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [apiLoading, isError, queryData]);

  const isStillLoading = loading || apiLoading;

  return { reflex, loading: isStillLoading };
};

export default useReflex;
